var map = {
	"./404Error-bro.png": "a123",
	"./Multitasking-bro-cel.png": "e965",
	"./Multitasking-bro.png": "8d39",
	"./Resumefolder-pana.png": "900d",
	"./bootstrap.png": "d4c1",
	"./bootstrapvue.png": "ce7f",
	"./css-3.png": "4731",
	"./curriculo/curriculo20212.png": "e2f9",
	"./electron.png": "9d8c",
	"./git.png": "43ac",
	"./github-white.png": "0cb9",
	"./github.png": "359c",
	"./html-5.png": "c58a",
	"./icons/global.png": "94a3",
	"./icons/instagram.png": "b069",
	"./icons/linkedin.png": "ea71",
	"./java.png": "3b8a",
	"./jquery.png": "854d",
	"./js.png": "f505",
	"./laravel.png": "138f",
	"./linkedin.png": "dd32",
	"./logo.png": "cf05",
	"./logomark.min.svg": "e1b0",
	"./mysql.png": "808d",
	"./perfil.jpg": "4ff7",
	"./php.png": "ec68",
	"./postgresql.svg": "079a",
	"./sql.png": "7779",
	"./vuejs.png": "2289",
	"./vuerouter.png": "a47f",
	"./vuetify.png": "40d1",
	"./vuex.png": "c665",
	"./yarn.svg": "c68c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";